<template>
	<v-card>
		<!-- <s-select-definition hidden @change="changeLayette($event)" label="Nro Canastilla" :def="1259"  /> -->
		<s-toolbar label="Abastecimiento" dark color="#8e8f91"></s-toolbar>
		<v-container>
			<v-tabs v-model="currentItem">
				<v-tab href="#Suplying"> Abastecer</v-tab>
				<v-tab href="#SuplyingEarring"> Pendientes por Abastecer</v-tab>
				<v-tab href="#SupplyofLots">Parihuelas Abastecidas</v-tab>
				<v-tab href="#SuplyingEarringDetail">Pendientes por Abastecer Detalle</v-tab>
			</v-tabs>

			<v-tabs-items v-model="currentItem">
				<v-tab-item :value="'Suplying'"> 
                   <supplying />
                </v-tab-item>

				<v-tab-item :value="'SuplyingEarring'"> 
                    <supplying-earring />
                </v-tab-item>
				
				<v-tab-item :value="'SupplyofLots'"> 
                    <supplying-of-lots />
                </v-tab-item>

				<v-tab-item :value="'SuplyingEarringDetail'"> 
                    <supplying-earring-detail />
                </v-tab-item>
			</v-tabs-items>
		</v-container>
	</v-card>
</template>
<script>
	//Component
	import Supplying from "./Supplying.vue";
    import SupplyingEarring from "./SupplyingEarring.vue";
	import SupplyingOfLots from "./SupplyingOfLots.vue";
	import supplyingEarringDetail from "./supplyingEarringDetail.vue";

	export default {
		components: { Supplying, SupplyingEarring, SupplyingOfLots, supplyingEarringDetail },
		data: () => ({
			currentItem: "tab-Funciones",
		}),
	};
</script>
